import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export async function fetchConfig() {
  const { data } = await client.get("/config");
  return data;
}

export async function fetchActivities() {
  const { data } = await client.get("/activities");
  return data;
}

export async function fetchActivity(slug) {
  const { data } = await client.get(`/activities/${slug}`);
  return data;
}
